import React from "react";

import { Plus } from "icons";

import { SubHeader, Button } from "clearsense-ui/components";

const PrimaryHeader = ({ openUploadPane }) => (
  <SubHeader
    breadcrumbs={[
      { label: "Archival Documents", link: "#" },
      { label: "All Documents", link: "/ingestion/archival-reports" },
    ]}
    actionBlock={
      <Button
        label="Upload Documents"
        data-cy="upload-documents-button"
        icon={Plus}
        onClick={openUploadPane}
      />
    }
    className="mt-8"
  />
);

export default PrimaryHeader;
